// This is a component to handle audio playback in the call summary details
import React, { useEffect, useRef } from 'react';
import { Label } from "@/components/ui/label";

const AudioPlayer = ({ recordingUrl, summaryId }) => {
  const audioRef = useRef(null);
  
  // This effect runs whenever the summaryId or recordingUrl changes
  useEffect(() => {
    // Get the current audio element from the ref
    const audioElement = audioRef.current;
    
    if (audioElement) {
      // Reset the audio element
      audioElement.pause();
      audioElement.currentTime = 0;
      
      // Force reload of the audio source
      audioElement.load();
    }
  }, [summaryId, recordingUrl]);
  
  if (!recordingUrl) return null;
  
  return (
    <div className="mt-4">
      <Label>Recording</Label>
      <audio ref={audioRef} controls className="w-full mt-2" key={summaryId}>
        <source src={recordingUrl} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};

export default AudioPlayer;